<template>
    <div class="jifen_body">

      <div class="jifen">
        <div class="keyong">可用积分</div>
        <div class="shuzi">{{myin}}</div>
      </div>

<!--      <div class="dui">-->
<!--        <div class="duihuan">-->
<!--          <div class="yuan">兑换订单</div>-->
<!--        </div>-->
<!--        <div class="jilu">-->
<!--          <div class="kuang">积分记录</div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="beij"></div>


        <van-tabs  v-model="activeName" v-if="activeKey==1">
          <van-tab title="积分订单" name="a">
            <van-empty description="暂时没有积分订单！" v-if="this.dingdan==null || this.dingdan.length==0"/>
            <div class="neirongs" v-for="item in dingdan">
              <div>
<!--                <h3><img :src="item.covermap" alt="">罗超</h3>-->
                <dl>
                  <dt><img src="/integral_goods.png" width="100%" alt=""></dt>
                  <dd style="overflow: hidden;text-overflow: ellipsis;width: 230px;white-space: nowrap;">
                    {{item.titles}}<span></span></dd>
                  <dd>{{item.integral}}积分
<!--                    <button @click="quxiao(item)">取消订单</button>-->
<!--                    <button @click="show1=true">立即支付</button>-->
                  </dd>
                </dl>
                <div>
                  <p><span>状态</span><span>已兑换</span></p>
                  <p><span>兑换时间</span><span>{{item.addtime}}</span></p>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="积分商品列表" class="integral" name="b">
            <van-empty description="暂时没有积分商品！" v-if="this.list==null || this.list.length==0"/>
            <dl v-for="item in list" @click="showPopup">
              <dt><img :src="item.covermap" width="100%" alt=""></dt>
              <dd>
                <p>{{item.titles}}</p>
                <p>{{item.introduce}}</p>
                <p>{{item.actualstock}}/{{item.stock}}（剩余）</p>
                <p>{{item.integral}}<span>积分</span></p>
              </dd>
              <dd @click="confirm(item)">立即兑换</dd>
            </dl>
          </van-tab>
          <van-tab title="积分明细" name="c">
            <van-empty description="暂时没有积分明细！" v-if="this.mingxi==null || this.mingxi.length==0"/>
            <div class="mingxi" v-for="item in mingxi">
              <div>{{item.contents}}</div>
              <div v-if="item.types==1">+{{item.changes}}分</div>
              <div v-if="item.types==2">-{{item.changes}}分</div>
              <div>{{item.addtime}}</div>
            </div>
          </van-tab>


        </van-tabs>

<!--      <van-popup v-model="show" position="bottom" :style="{ height: '30%' }" >-->
<!--        <van-divider>商品简介</van-divider>-->
<!--        <p class="zhengwen"></p>-->
<!--      </van-popup>-->



<!--      <van-tabbar v-model="active">-->
<!--        <van-tabbar-item icon="home-o" @click="shouye">首页</van-tabbar-item>-->
<!--        <van-tabbar-item icon="search" @click="ziyuanku">资源库</van-tabbar-item>-->
<!--        <van-tabbar-item icon="friends-o" @click="wode">我的</van-tabbar-item>-->
<!--        <van-tabbar-item icon="setting-o" @click="jifen">积分商城</van-tabbar-item>-->
<!--      </van-tabbar>-->



    </div>
</template>

<script>
    import { Dialog } from 'vant';
    export default {
        name: "integral",
        data(){
            return{
                show:false,
                active:0,
                activeName:'b',
                activeKey:1,
                value:['1'],
                list:[],
                myin:'',
                mingxi:[],
                dingdan:[],
            }
        },
        created() {
            this.getdata()
            this.getcity()
            this.getjifen()
            console.log(143242)
        },
        methods:{
            showPopup() {
                this.show = true;
            },
            //兑换跳转
            confirm(item){
                this.$router.push({ path:'/exchange',query:{id:item.id}})
            },
            getdata() {
                this.myrequest({
                    url:'/client/getintegralgoods.action',
                    types:'get',
                    data:{
                        // token:this.$store.state.token
                    },
                    succ: (res) => {
                        this.list=res.data
                        this.myin=res.myintegral
                    },
                    errs: (msg) => {

                    }
                })
            },
            getcity() {
                this.myrequest({
                    url:'/client/getintegrallist.action',
                    types:'get',
                    data:{
                        // token:this.$store.state.token
                    },
                    succ: (res) => {
                        this.mingxi=res.data
                    },
                    errs: (msg) => {

                    }
                })
            },
            getjifen() {
                this.myrequest({
                    url:'/client/geroderlist.action',
                    types:'get',
                    data:{
                        // token:this.$store.state.token
                    },
                    succ: (res) => {
                        this.dingdan=res.data
                    },
                    errs: (msg) => {

                    }
                })
            }
        }

    }
</script>

<style scoped lang="stylus">
  .neirongs {
    width 95%;
    margin auto;
    background-color #fcfcfc;
    border-radius 5px
    /*height 200px*/

    > div {
      width: 100%

      h3 {
        font-size 11pt
        font-weight 500
        padding 10px 15px
        line-height 30px
        /*border-bottom 1px solid #eee*/
        margin-bottom 0

        img {
          width 30px
          height 30px
          border-radius 50%
          display inline-block
          margin-right 3px
          float left
        }
      }

      dl {
        padding 10px 15px
        margin 0
        overflow auto

        dt {
          width 80px
          height 80px
          float left
          margin-right 8px
        }

        dd:nth-of-type(1) {
          font-size 12pt
          font-weight 500
          line-height 40px

          span {
            font-size 8pt
            color #666
            float right
            font-weight 400
          }
        }

        dd:nth-of-type(2) {
          font-size 11pt
          line-height 200%
          color #e9353e
          font-weight 500

          button {
            background-color #ffebe8
            border none
            font-size 9pt
            border-radius 50px
            padding 0 12px
            float right
            margin-left 5px
            font-weight 400
          }
        }
      }

      > div {
        width 100%
        border-top 1px solid #eee
        display flex

        p {
          flex 33.3%
          display block
          text-align center
          border-right 1px dotted #eee

          span {
            display block
            font-size 10pt
            line-height 20px
          }

          span:first-child {
            font-size 8pt
            color: #666
          }
        }
      }
    }
  }
  .zhengwen{
    width 90%;
    margin auto;
  }
  >>>.van-button--primary{
    border 0px
  }

    .integral {

      * {
        box-sizing border-box
      }


      dl {
        width 100%
        overflow auto
        padding 10px 15px
        position relative
        border-bottom 1px solid #f6f6f6
        margin 0

        dt {
          width 120px
          height 120px
          float left
          margin-right 10px
        }

        dd:nth-of-type(1) {
          height 120px
          overflow hidden

          p {
            margin 0
          }

          p:first-child {
            line-height 180%
            font-size 12pt
            font-weight 500
            display -webkit-box
            -webkit-box-orient vertical
            -webkit-line-clamp 1
            overflow hidden
          }

          p:nth-of-type(2) {
            font-size 9pt
            color #666
            display -webkit-box
            -webkit-box-orient vertical
            -webkit-line-clamp 2
            overflow hidden
            margin-bottom 10px
          }

          p:nth-of-type(3) {
            font-size 7pt
            color #666
          }

          p:nth-of-type(4) {
            font-size 14pt
            font-weight 500
            color #e9353e

            span {
              font-size 9pt
              margin-left 2px
            }
          }
        }

        dd:last-child {
          position absolute
          bottom 10px
          right 15px
          background-color #ffebe8
          color #e9353e
          padding 6px 12px
          border-radius 50px;
        }
      }
    }

  .duohang{
    color: #ccc;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size 8pt !important;
    margin-bottom 20px;
  }
  .jifen_body{
    >>>.van-button--primary{
      background-color #0AC1BA;
    }
    >>>.van-button--mini{
      border-radius 5px;
      margin-left 20px
    }
    .jifen{
      width 100%;
    }
    .keyong{
      text-align center;
      font-size 16px;
      margin-top 20px;
    }
    .shuzi{
      font-size 20pt
      text-align center;
      margin 15px 0;
      font-weight bold;

    }
    .dui{
      width 60%;
      display flex;
      margin 0 auto;
      margin-top 10px;
    }
    .duihuan{
      width 50%;
      text-align center;
    }
    .jilu{
      width 50%;
      text-align center;
    }
    .yuan{
      border 1px solid #e9353e;
      width 70px;
      height 30px;
      line-height 30px;
      border-radius 4px;
      margin auto;
      color #e9353e
    }
    .kuang{
      border 1px solid #e9353e
      width 70px;
      height 30px;
      line-height 30px;
      border-radius 4px;
      margin auto;
      color #e9353e
    }
    .beij{
      background-color #fafafa;
      width 100%;
      height 5px;
      margin-top 20px;
    }
    .jifenduihuan{
      color #000000;
      font-weight bold;
      margin-left 40px;
      margin-top 10px;
      margin-bottom 10px;
    }
    .mingxi{
      width 100%;
      display flex;
      border-bottom 1px solid #fafafa;
      height 50px;
      div{
        margin-top 20px;
        width 33.3%;
        text-align center;
        color #333333
      }
    }
    .tupian{
      float left;
      width 50%;
      /*margin-right 10px;*/
      margin-bottom 10px;
      /*margin-top 10px;*/
      /*text-align center*/
      img{
        width 95%;
        border-radius 3px;
        height 120px;
      }
    }
    .neirong{
      float left;
      width 50%;
      /*margin-top 20px;*/
      /*margin-left 10px;*/
      div{
        color #ccc;
        margin-top 5px;
        font-size 14px;
      }
    }
    .wei{
      width 93%;
      margin 10px auto;
      overflow auto
      /*border-bottom 5px solid #fafafa*/
    }
    .shiping {
      position relative;
      margin-top 10px;
      border-bottom 1px solid #fafafa;
      height 20px;
      >>> .van-collapse-item__content {
        padding 0px;
      }
      width 90%;
      margin 10px auto;
      display flex;

      .xiabiao {
        /*margin-right 10px;*/
        width 33%;
        text-align center
      }
      .shijian{
        width 33%;
        text-align center
      }

      .kecheng {
        width 33%;
        text-align center
      }

      .bofang {
        position absolute;
        right 0px;

        img {
          width 20px;
          height 20px;
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/integral.vue